import { render, staticRenderFns } from "./table_editing.vue?vue&type=template&id=23a16178&scoped=true&"
import script from "./table_editing.vue?vue&type=script&lang=ts&"
export * from "./table_editing.vue?vue&type=script&lang=ts&"
import style0 from "./table_editing.vue?vue&type=style&index=0&id=23a16178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a16178",
  null
  
)

export default component.exports